import { render, staticRenderFns } from "./AddStartup.vue?vue&type=template&id=d461ff2c&scoped=true&"
import script from "./AddStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d461ff2c",
  null
  
)

export default component.exports